const AI_PROVIDER_CHANGE_EVENT = "ai-provider-change";

const notifyProviderChange = (provider) => {
  window.dispatchEvent(new CustomEvent(AI_PROVIDER_CHANGE_EVENT, { detail: { provider } }));
};

export const isMockAgentEnabled = () => localStorage.getItem("ai_provider") === "mock_agent";

export const setMockAgentEnabled = (enabled) => {
  if (enabled) {
    const currentProvider = localStorage.getItem("ai_provider") || "omini";
    if (currentProvider !== "mock_agent") {
      localStorage.setItem("mock_agent_previous_provider", currentProvider);
    }
    localStorage.setItem("ai_provider", "mock_agent");
    notifyProviderChange("mock_agent");
    return "mock_agent";
  }

  const previousProvider = localStorage.getItem("mock_agent_previous_provider") || "omini";
  localStorage.setItem("ai_provider", previousProvider === "mock_agent" ? "omini" : previousProvider);
  const provider = localStorage.getItem("ai_provider") || "omini";
  notifyProviderChange(provider);
  return provider;
};
